import { render } from "./structuralComponent.vue?vue&type=template&id=a8ca633c&scoped=true"
import script from "./structuralComponent.vue?vue&type=script&lang=js"
export * from "./structuralComponent.vue?vue&type=script&lang=js"

import "./structuralComponent.vue?vue&type=style&index=0&id=a8ca633c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ca633c"]])

export default __exports__